const en = {
  auth: {
    email: `Email`,
    password: `Password`,
    login: `Login`,
    logout: `Log out`,
    create_an_account: `Create an account?`,
    forgot_password: `Forgot password?`,
  },
  login: {
    title: `Sign in to TreePlotter Mobile`,
    greeting: `Hi, welcome back`,
    new_user: `New user?`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  // tp-mobile
  inventory: `Inventory`,
  organization: `Organization`,
  asset_class: `Inventory`,
  asset_class_with_tenant: `Inventory | {{tenant}}`,
  inspections: {
    start_basic_inspection: 'Start Basic Inspection',
    submit: 'Submit Inspection',
    inspection_details: 'Inspection Details',
    tree_details: 'Tree Details',
    inspection_on: 'Inspection on {{date}}',
  },
  greeting_with_name: `Let's plot some trees!`, // TODO: Put back the user's first name
  account: `account`,
  tenant: 'account',
  tenant_select_ui: 'Select Account',
  tenant_list_ui: 'Accounts',
  tenant_switch_dialog_title: 'Select Account',
  tenant_switch_dialog_message: 'Please select an account to continue',
  confirm: 'Confirm',
  no_tenant_found: 'No account found',
  no_tenant_found_error: 'No account was found. This is an error, please contact support below.',
  error: `Error`,
  error_detected: `We've detected an error in our system.`,
  contact_support_if_persists: 'Please contact support if the issue persists.',
  error_details_below: `You can view details about the specific error below:`,
  contact_support: 'Contact Support',
  error_pun_message: 'Well, this is unbe‑leaf‑able…\nsomething went wrong.',
  error_reset_instruction: "Something isn't configured correctly.\nTap reset to fix it.",
  error_contact_support_if_needed: 'Contact support if needed',
  logout: `logout`,
  forgot_password: `forgot password`,
  tenant_switched_simple: 'Your account has been switched.',
  features: `features`,
  are_you_sure_proceed: `Are you sure you want to proceed?`,
  settings: `Settings`,
  application_name_version: `TreePlotter MOBILE Version`,
  settings_screen: {
    greeting: 'Hello!',
    current_app_version: 'Current App Version',
    version_information_unavailable: 'Version information unavailable',
  },
  data: {
    save: `Save`,
    load_last: `Load Last`,
    load_last_title: `Load Last Asset`,
    load_last_prompt: `Are you sure you want to load the last loaded asset? This will overwrite all unsaved changes.`,
    edit: `Edit`,
    sync: `Sync`,
    sync_assets: `Sync Assets`,
    bulk_sync_treeplotter: `Bulk Sync Assets from TreePlotter`,
    edit_item: `{{layerName}} Details`,
    view_item: `{{layerName}} Details`,
    create_new_item: `Add a new {{layerName}}`,
    ignore_changes: `Ignore Changes`,
    ignore_changes_prompt: `You have chosen to exit the form without saving changes. Are you sure?`,
    ignore_changes_with_photos: `Ignore Changes & Pending Uploads`,
    ignore_changes_with_photos_prompt: `You have unsaved changes and pending photo uploads. Are you sure you want to close the form?`,
    save_changes: `Save Changes`,
    save_changes_prompt: `You have chosen to exit the form without saving changes. Are you sure?`,
    continue: `Continue`,
    delete: `Delete`,
    delete_prompt: `Are you sure you wish to remove the selected {{item}}?`,
    item_id: `{{layerName}} ID:`,
    create_successful: `{{title}} created successfully!`,
    create_error: `Failed to create {{title}}. Please try again.`,
    update_successful: `{{title}} updated successfully!`,
    update_error: `Failed to update {{title}}. Please try again.`,
    create_queued: `{{title}} saved. It will be created when you're back online.`,
    update_queued: `{{title}} saved. Changes will sync when you're back online.`,
    queued_submit_failed: `Couldn't send your offline changes (asset {{assetId}}). Please try again.`,
    photo_link_failed: `Couldn't attach the photo to asset {{assetId}}. Please try again.`,
  },
  reset: `Reset`,
  cancel: `Cancel`,
  yes: `Yes`,
  no: `No`,
  ok: `OK`,
  loading: `Loading...`,
  asset: {
    edit_error_title: `Unable to Edit Asset`,
    edit_error_message: `This asset is still loading or missing required data. Please try again in a moment.`,
    load_error_title: `Failed to Load Data`,
    load_error_message: `We are unable to load {{assetClass}} data at this time. Please try again.`,
    retry: `Retry`,
    invalidConfiguration: `Invalid Configuration`,
  },
  field: {
    inventory_field_configuration_issue: `We have detected an issue with your Inventory's Field Configuration. You must refresh your page to continue inventorying.`,
  },
  home: {
    slug: `home`,
    greeting: `Hello!`,
    current_tenant: `Current Account: `,
    my_location: `My Location`,
    select_organization_required: `Please select an organization to start plotting trees.`,
    get_to_know_planitgeo: `Get to know PlanIT Geo`,
    help: `How can we help?`,
    chat: `Let's have a chat.`,
    support: `Support`,
    contact_us: `Contact us`,
  },
  map: {
    filter: `Filter`,
    filter_sidebar_title: `Map Filters`,
    organizations: `Organizations`,
    select_organization: `Organization`,
    load: `Load`,
    close: `Close`,
    display_by: `Display By`,
    view_controls: `Map View Controls`,
    reference_layers: `Reference Layers`,
    base_map: `Base Map`,
    show_all_trees: `Show All Trees`,
    filter_min: `Min`,
    filter_max: `Max`,
    filter_range_invalid: `Min must be less than or equal to max.`,
    coming_soon: `Coming Soon`,
    legend: `Legend`,
    no_legend_data: `No data available.`,
    legend_additional_trees: `Non-matching`,
    legend_not_specified: `Not Specified`,
    user_location: `My Location`,
    filters_coming_soon: `Filters coming soon`,
    move_asset: `Move {{layerName}}`,
    move_asset_subtext: `Pan the map to position the pin, then confirm.`,
    move_asset_select_first: `Tap a {{layerName}} to select it for moving.`,
    move_asset_panel_title: `Move {{layerName}} #{{id}}`,
    move_asset_panel_subtext: `Drag map to place pin.`,
    move_asset_confirm_title: `Confirm Move`,
    move_asset_confirm_message: `Move {{layerName}} to this location?`,
    move_asset_success: `{{layerName}} moved successfully`,
    move_asset_refresh_failed: `{{layerName}} moved successfully, but map refresh failed. Please refresh the page.`,
    move_asset_error: `Failed to move {{layerName}}`,
    move_asset_error_unexpected: `An unexpected error occurred while moving {{layerName}}`,
    move_asset_cancelled: `Move {{layerName}} cancelled`,
    load_last_asset: `Bulk Load Last`,
    load_last_asset_subtext: `Press and hold to add {{layerName}}s with last data.`,
    load_last_asset_error: `Failed to create {{layerName}} with last loaded data`,
    load_last_asset_no_data: `No previously loaded {{layerName}} data available`,
    load_last_asset_staged: `{{layerName}} added`,
    load_last_asset_flush_success: `{{count}} {{layerName}}(s) created with last loaded data`,
    load_last_asset_flush_error: `Failed to save added {{layerName}}s`,
    load_last_complete: `Complete`,
    load_last_cancel_title: `Cancel Bulk Load Last`,
    load_last_cancel_message: `This will remove {{count}} added {{layerName}}(s).`,
    load_last_cancel_remove: `Remove`,
    load_last_cancel_keep: `Keep Adding`,
    add_asset: `Add {{layerName}}`,
    add_asset_subtext: `Press and hold on map at any time to add a {{layerName}}.`,
    map_actions: `Map Actions`,
    tree: `Tree`,
    work: `Work`,
    priority: `Priority`,
    center_error: `Could not get map center`,
    no_assets_match_filters: `No assets match the selected filters`,
    zoom_out: `Zoom Out`,
    clear_filters: `Clear Filters`,
    showing_partial_matches: `{{shown}} of {{total}} Work Tasks available`,
    dismiss: `Dismiss`,
  },
  common: {
    close: `Close`,
  },
  photos: {
    section_title: `Add Photos`,
    error_adding_photos: `Error adding photos`,
    unknown_error: `An unknown error occurred`,
    file_too_large: `File is too large. Please select a smaller image.`,
    file_too_large_offline: `File is too large for offline use. Please connect to the internet or select a smaller image.`,
    save_first_title: `Save first to Add Photos!`,
    save_first_content: `Please save the asset first to upload and manage photos. This ensures your photos are properly linked to the correct asset.`,
    save_first_button: `Save Asset`,
    no_photos_linked: `No photos linked to this asset.`,
    loading_photos: `Loading photos...`,
    use_camera_or_library: `Use Camera or Library`,
    use_camera: `Camera`,
    use_library: `Library`,
    choose_photo_source: `Choose Photo Source`,
    addPhotoAria: `Add photo`,
    delete_photo: `Delete Photo`,
    delete_photo_prompt: `Are you sure you want to delete this photo? This action cannot be undone.`,
    delete_photo_success: `Photo deleted successfully`,
    delete_photo_error: `Failed to delete photo. Please try again.`,
    failed_to_load: `Failed to load photo`,
    failed_to_load_image: `Failed to load image`,
    max_photos_reached: `Photo limit reached`,
    offline_mode: `Offline Mode`,
    upload_pending_title: `PHOTO UPLOAD PENDING`,
    upload_pending_content: `You have pending photo uploads. Are you sure you want to close the form before these uploads complete?`,
    unsaved_changes_title: `UNSAVED CHANGES`,
    unsaved_changes_content: `You have unsaved changes. Are you sure you want to close the form?`,
    unsaved_changes_with_photos_title: `UNSAVED CHANGES`,
    unsaved_changes_with_photos_content: `You have unsaved changes and pending photo uploads. Are you sure you want to close the form?`,
    work_task_photo: `Work Task`,
    inspection_photo: `Inspection`,
    view_photos: `View Photos`,
    all_photos: `All Photos`,
    added_date: `Added {{date}}`,
    context_tree_details: `Tree details`,
    context_inspection: `Inspection`,
    context_work_task: `Work task`,
    no_photos: `No photos`,
    previous: `Previous photo`,
    next: `Next photo`,
  },
  accessibility: {
    color_vision_accessibility: `Color Vision Accessibility`,
    choose_color_palette: `Use achromatopsia (grayscale) colors.`,
    default_colors: `Default Colors`,
    protanopia: `Protanopia (Red-blind)`,
    deuteranopia: `Deuteranopia (Green-blind)`,
    tritanopia: `Tritanopia (Blue-blind)`,
    achromatopsia: `Achromatopsia (Complete color blindness)`,
  },
  fullscreen: {
    title: `Fullscreen Mode`,
    description: `Hide the address bar for a cleaner view. Not supported in all browsers.`,
    enter: `Go Fullscreen`,
    exit: `Exit Fullscreen`,
    enabled: `Enabled`,
    disabled: `Disabled`,
    not_supported: `Fullscreen mode is not supported in this browser`,
    error: `Failed to enter fullscreen mode`,
  },
  organizations: {
    no_organizations_available: `No organizations available`,
    organizations_load_error: `Failed to load organizations`,
  },
  privacy: {
    cookie_management: 'Privacy and cookies',
    manage_cookie_preferences: 'Manage Cookie Preferences',
    review_preferences: 'Review preferences',
    manage_cookie_preferences_description: 'Manage cookies and tracking.',
  },
  sync: {
    sync_data: 'Sync Data',
    sync_data_description:
      'Synchronize data between systems to ensure all fields from TP2 are available. This resolves any missing references and updates the database with the latest information. Please wait about 1 minute, then log out and back in to see the changes.',
    syncing: 'Syncing...',
    sync_complete: 'Syncing in progress, this might take a few seconds',
    sync_error: 'Sync Failed',
  },
  support: {
    get_help: 'Get Help',
    how_can_we_help: 'Need help?',
    visit_our_support_site: 'Visit Support for FAQs or to contact us.',
  },
  haptic: {
    settings_title: 'Haptic Feedback',
    settings_description: 'Device vibrates on tap. Not available on all devices.',
    enabled: 'Haptic feedback enabled',
    disabled: 'Haptic feedback disabled',
  },
  work: {
    title: `Work`,
    tasks: `Tasks`,
    open: `Open`,
    completed: `Completed`,
    none: `None`,
    create: {
      title: `Create Work`,
      add: `Add work task`,
      task_type: `Task Type`,
      task_type_required: `Task type is required`,
      assignee: `Assignee`,
      due_date: `Due Date`,
      unassigned: `Unassigned`,
      all: `All`,
      no_due_date: `No Due Date`,
      clear: `Clear`,
      submit_error: `Couldn't create work. Please try again.`,
      add_photo: `Add photo`,
      remove_photo: `Remove photo {{name}}`,
      queued_offline: `Work saved. It will be created when you're back online.`,
      submit_failed: `Couldn't finish {{step}} (asset {{assetId}}). The work was discarded.`,
      failed_step: {
        host: `saving the record`,
        asset: `creating the asset`,
        work: `creating the work`,
        photos: `attaching the photos`,
      },
    },
    priority: {
      not_specified: `Not Specified`,
      low: `Low`,
      medium: `Medium`,
      high: `High`,
      urgent: `Urgent`,
    },
  },
  work_task: {
    upload: {
      starting: `Starting upload...`,
      queued: `Photo queued for upload`,
    },
  },
  arm: {
    start_basic_inspection: 'Basic Inspection',
    tree_details: 'Details',
    work: 'Work',
    move_asset: 'Move Asset',
    tree_history: 'History',
    inspection: 'Inspection',
    work_coming_soon: 'Work action coming soon',
    history_event_basic_inspection: 'Basic Inspection',
    history_event_basic_risk_assessment: 'Basic Risk Assessment',
    risk_assessment_on: 'Risk Assessment on {{date}}',
    risk_rating: 'Risk Rating',
    risk_rating_low: 'Low',
    risk_rating_moderate: 'Moderate',
    risk_rating_high: 'High',
    risk_rating_extreme: 'Extreme',
    risk_rating_helper: 'Calculated from selections.',
    history_comments: 'Comments',
    history_no_value: '—',
    history_empty: 'No history yet for this item.',
    history_error: 'Could not load history. Please try again.',
    history_photo_alt: 'Inspection photo',
    history_photo_close: 'Close',
    history_photo_load_failed: 'Failed to load image',
    history_sort_label: 'Sort order',
    history_sort_newest: 'Newest First',
    history_sort_oldest: 'Oldest First',
    history_filter_all: 'All',
    history_filter_photos: 'Photos',
    history_expand_all: 'Expand all',
    history_collapse_all: 'Collapse all',
    history_no_filtered: 'No entries match this filter.',
    inspection_submit: 'Submit Inspection',
    inspection_submit_success: 'Inspection submitted',
    start_basic_risk_assessment: 'Basic Risk Assessment',
    inspection_submit_error: 'Failed to submit inspection. Please try again.',
    inspection_missing_identifier: 'This item cannot be inspected until it has finished syncing.',
    inspection_no_fields: 'No inspection fields are configured for this item.',
    inspection_submit_queued: 'Inspection saved. It will sync when you are back online.',
    inspection_notes_label: 'Inspection notes',
    inspection_notes_placeholder: 'Add a note for this inspection (optional)',
    risk_notes_label: 'Risk Assessment Notes',
    risk_notes_placeholder: 'Add a note for this risk assessment (optional)',
    back_to_forms: 'Back to forms',
    form_basic_inspection: 'Basic Inspection',
    form_basic_inspection_description: 'Record tree conditions and observations.',
    form_basic_risk_assessment: 'Basic Risk Assessment',
    form_basic_risk_assessment_description: 'Evaluate tree risk to help prioritize follow-up work.',
    inspection_add_photo: 'Add photo',
    inspection_photo_limit_reached: 'You have reached the maximum number of photos.',
    asset_add_photo: 'Add photo',
    asset_photo_limit_reached: 'You have reached the maximum number of photos.',
    last_modified_by: 'by {{user}} on {{date}}',
    inspection_offline_banner:
      'You are offline. Your inspection will be submitted when you reconnect.',
    form_offline_banner: 'You are offline. Your changes will be submitted when you reconnect.',
  },
  risk_assessment: {
    submit: 'Submit Risk Assessment',
    submitted: 'Risk Assessment submitted',
  },
  work_list: {
    filters: 'Filters',
    filter_assigned_to: 'Assigned to',
    filter_task_type: 'Task Type',
    filter_priority: 'Priority',
    filter_work_order: 'Work Order',
    filter_status: 'Status',
    filter_all: 'All',
    filter_options_error: 'Unable to load filter options from server. Showing local filters.',
    showing_count: `Showing {{shown}} of {{total}} results`,
    apply_filters: 'Apply',
    clear_filters: 'Clear',
    error_user_id_not_available: 'User ID not available',
    error_tenant_id_not_available: 'Account ID not available',
    error_task_not_found: 'Task not found',
    error_completing_work_task: 'Error completing work task',
    error_restarting_work_task: 'Error restarting work task',
    mark_incomplete_dialog_title: 'Mark Task Incomplete?',
    mark_incomplete_dialog_message: 'This will move the task back to your Tasks list.',
    mark_incomplete_action: 'Mark Incomplete',
    no_tasks: 'No tasks available',
    no_completed_tasks: 'No completed tasks',
    no_results: 'No results found',
    connection_warning: 'Some tasks are not showing. Retry with better connection.',
    syncing_warning: 'Some tasks are not showing. Syncing…',
    aria_region_label: 'Work tasks list with pagination',
    aria_pagination_nav: 'Work tasks pagination',
    aria_pagination_controls: 'Pagination controls, page {{currentPage}} of {{totalPages}}',
    aria_tasks_list:
      'Work tasks, showing {{currentItems}} of {{totalItems}} items (page {{currentPage}} of {{totalPages}})',
    aria_go_to_page: 'Go to page {{page}}',
    aria_previous_page: 'Go to previous page, page {{page}}',
    aria_previous_page_disabled: 'Previous page (disabled)',
    aria_next_page: 'Go to next page, page {{page}}',
    aria_next_page_disabled: 'Next page (disabled)',
    aria_task_item:
      'Work task {{itemNumber}} of {{totalItems}}: {{title}}, {{description}}{{workOrder}}, {{status}}',
    aria_task_completed: 'completed',
    aria_task_not_completed: 'not completed',
    aria_mark_complete: 'Mark "{{title}}" as complete',
    aria_mark_incomplete: 'Mark "{{title}}" as incomplete',
    aria_priority: 'Priority: {{priority}}',
    unable_to_load_work_tasks: `Error: Unable to load work tasks`,
    species_unknown: 'Species Unknown',
    show_in_map: 'Show in map',
    work_order: 'WO: {{name}}',
    unknown: 'Unknown',
    photo_upload_success: 'Photo uploaded successfully',
    photo_upload_error: 'Failed to upload photo',
    photos_upload_success: '{{count}} photos uploaded successfully',
    photos_upload_error: 'Failed to upload {{count}} photos',
    photo_limit_reached: 'Photo limit reached (maximum 5 photos)',
    aria_add_photo: 'Add photo to "{{title}}"',
  },
  formPlayer: {
    error: 'Failed to load form',
    retry: 'Retry',
    noFields: 'This form has no fields configured.',
  },
  nav: {
    home: 'Home',
    map: 'Map',
    settings: 'Settings',
  },
  forms: {
    dbh_multistem_add_stem: 'Add stem',
    dbh_multistem_remove_stem: 'Remove stem {{number}}',
    dbh_multistem_stem_input_label: 'Stem {{number}} diameter',
    dbh_multistem_stem_count_singular: '{{count}} stem',
    dbh_multistem_stem_count_plural: '{{count}} stems',
    dbh_multistem_stem_n_label: 'Stem {{number}}',
    dbh_multistem_calculated_label: 'Calculated DBH',
    dbh_multistem_add_stem_inline_label: '+ Stem',
    add_new_asset: 'Add New Asset',
    basic_information: 'Basic Information',
    details: 'Details',
    location: 'Location',
    coordinates: 'Coordinates',
  },
};

export default en;
